import React, { PureComponent } from 'react';
import { string, bool, func, object, oneOfType } from 'prop-types';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import eyeIcon from '../../assets/images/eye-icon.png';
import eyeIconCrossed from '../../assets/images/eye-icon-crossed.png';

import styles from './PasswordInput.module.scss';

class PasswordInput extends PureComponent {
  static propTypes = {
    id: string.isRequired,
    autoFocus: bool,
    margin: string,
    className: string,
    value: string,
    defaultValue: string,
    error: bool,
    helperText: oneOfType([object, string]),
    label: oneOfType([object.isRequired, string.isRequired]),
    onChange: func.isRequired,
    style: object,
    sx: object,
  };

  static defaultProps = {
    margin: 'normal',
  };

  state = {
    showPassword: false,
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const {
      id,
      className,
      value,
      defaultValue,
      error,
      helperText,
      label,
      autoFocus,
      margin,
      onChange,
      style,
      sx,
    } = this.props;

    return (
      <TextField
        id={id}
        defaultValue={defaultValue}
        value={value}
        fullWidth
        error={error}
        helperText={helperText}
        label={label}
        autoFocus={autoFocus}
        margin={margin}
        className={className}
        type={this.state.showPassword ? 'text' : 'password'}
        style={style}
        sx={sx}
        onChange={onChange}
        FormHelperTextProps={{ className: styles.helperText }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment>
                <IconButton onClick={this.handleClickShowPassword}>
                  {this.state.showPassword ? (
                    <img className={styles.eyeIcon} src={eyeIcon} alt="" />
                  ) : (
                    <img className={styles.eyeIcon} src={eyeIconCrossed} alt="" />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    );
  }
}

export default PasswordInput;
